import loaderGif from '../assets/loader.gif';

const LoadingSpinner = () => {
	return (
		<div
			style={{
				position: 'fixed',
				top: 0,
				left: 0,
				bottom: 0,
				right: 0,
				width: '100%',
				height: '100%',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				backgroundColor: 'transparent',
				zIndex: 1000,
			}}>
			<img
				src={loaderGif}
				alt='Loading...'
				style={{
					width: '50px',
					height: '50px',
				}}
			/>
		</div>
	);
};

export default LoadingSpinner;
